import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const POLL_INTERVAL = 60_000;

export default function useVersionCheck() {
  const currentVersion = useRef<string | null>(null);
  const toastShown = useRef(false);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now(), {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const { version } = await res.json();

        if (currentVersion.current === null) {
          currentVersion.current = version;
          return;
        }

        if (version !== currentVersion.current && !toastShown.current) {
          toastShown.current = true;
          toast.info(
            <span>
              An update is available. Refresh or{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.reload();
                }}
                style={{ color: 'inherit', fontWeight: 'bold' }}
              >
                click here
              </a>{' '}
              to apply the update.
            </span>,
            { duration: Infinity },
          );
        }
      } catch {
        // Network error — silently ignore
      }
    };

    check();
    const id = setInterval(check, POLL_INTERVAL);
    return () => clearInterval(id);
  }, []);
}
